<template>
  <div class="fp fp--catalog">
    <div class="fp-list">
      <FrontPhoto />
      <div class="fp-list-item" v-for="group in list">
        <div class="fp-list-slider">
          <a :href="item.url" class="fp-item fp-item--2" :class="{ 'fp-item--active': index == 0 }"
            v-for="(item, index) in group">
            <div class="fp-item-picture" :style="'background-image: url(' + item.image + ')'"></div>
            <div class="fp-item-content">
              <div class="fp-item-marks" v-if="item.period">
                <div class="fp-item-mark">
                  {{ item.period }}
                </div>
              </div>
              <div class="fp-item-title">
                <div class="fp-item-title-content">
                  <div class="item" v-html="item.name"></div>
                </div>
              </div>
              <div class="fp-item-text" v-if="item.text">
                <div class="fp-item-text-content">
                  {{ item.text }}
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import FrontPhoto from './FrontPhoto.vue'

export default {
  components: { FrontPhoto },
  data() {
    return {
      list: []
    }
  },
  methods: {
    getList() {
      axios.get('/slider/get-promos').then((response) => {
        this.list = response.data || []
        this.$nextTick(this.toggleSlides)
      })
    },
    toggleSlides() {
      for (const slider of this.$el.querySelectorAll('.fp-list-slider')) {
        const slides = slider.querySelectorAll('.fp-item')
        if (slides.length < 2) {
          continue
        }

        let currentIndex = 0
        const maxIndex = slides.length - 1

        setInterval(() => {
          slider.querySelector('.fp-item--active').classList.remove('fp-item--active')
          currentIndex = currentIndex + 1 > maxIndex ? 0 : currentIndex + 1
          slides[currentIndex].classList.add('fp-item--active')
        }, 8000)
      }
    }
  },
  created() {
    this.getList()
  }
}
</script>